export default __webpack_public_path__ + "7edc1ae56db7dadd6e8e45d39fb66694.svg";